// =============================================================================
// EmailHubDashboard — wrapper unifié 2 onglets (Pending Actions + AG-04 trace)
// =============================================================================
// Remplace les 2 entrées nav historiques `agent-email` (EmailWorkerDashboard)
// et `ag04-amo` (AG04Dashboard) qui montraient des données désynchronisées.
// Wrapper minimal : pas de refactor des 2 dashboards, juste co-localisation
// dans un Tabs unique pour cohérence UX.

import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../components/ui/tabs";
import { Inbox, Workflow } from "lucide-react";

import EmailWorkerDashboard from "./EmailWorkerDashboard";
import AG04Dashboard from "./AG04Dashboard";

export default function EmailHubDashboard({ initialTab = "pending" }) {
  const [activeTab, setActiveTab] = useState(initialTab);

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <Inbox className="w-6 h-6" style={{ color: "var(--oh-stat-blue-text)" }} />
        <div>
          <h1 className="text-xl font-bold" style={{ color: "var(--oh-text)" }}>
            Email Hub — amo@
          </h1>
          <p className="text-sm" style={{ color: "var(--oh-text-muted)" }}>
            Traitement automatique des mails ANAH (worker IMAP + classifier AG-04 v2)
          </p>
        </div>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="bg-slate-800/50 border border-slate-700/50 p-1">
          <TabsTrigger value="pending" className="data-[state=active]:bg-slate-700">
            <Inbox className="w-4 h-4 mr-1" /> Pending actions (legacy)
          </TabsTrigger>
          <TabsTrigger value="ag04" className="data-[state=active]:bg-slate-700">
            <Workflow className="w-4 h-4 mr-1" /> AG-04 v2 (trace)
          </TabsTrigger>
        </TabsList>
        <TabsContent value="pending" className="mt-4">
          <EmailWorkerDashboard />
        </TabsContent>
        <TabsContent value="ag04" className="mt-4">
          <AG04Dashboard />
        </TabsContent>
      </Tabs>
    </div>
  );
}
